import { AssetListItem } from '~src/spacesPlatform/models/AssetListItem';

const AllowedFavoriteContentTypes = {
  collection: 'collection',
  dataRole: 'dataRole',
  datasource: 'datasource',
  flow: 'flow',
  lens: 'lens',
  metric: 'metric',
  project: 'project',
  virtualConnection: 'virtualConnection',
  virtualConnectionTable: 'virtualConnectionTable',
  view: 'view',
  workbook: 'workbook',
  predictiveModel: 'predictiveModel',
  simulation: 'simulation',
};

export type FavoriteItemType = keyof typeof AllowedFavoriteContentTypes;

export function contentTypeCanBeFavorite(contentType: string): contentType is FavoriteItemType {
  return AllowedFavoriteContentTypes.hasOwnProperty(contentType);
}

export interface IFavorite extends AssetListItem {
  objectLuid?: string;
  objectType: FavoriteItemType;
  objectIdForFavoriting: string; // will match objectId except for datasources. See IDataSourceInfo
}

export const FavoriteKeys = {
  position: 'position'
};
